import { useRef } from 'react';
import { Capacitor } from '@capacitor/core';

export const useChapterNavigation = (playerRef, isMobile, setActiveMainTab) => {
  const scrollContainerRef = useRef(null);

  const parseTimeString = (time) => {
    if (!time) return null;

    // 시간 파싱
    const timeStr = time.replace(/\[|\]/g, '');
    const timeParts = timeStr.split(':');
    
    if (timeParts.length !== 2) return null;
    
    const minutes = parseInt(timeParts[0]);
    const seconds = parseInt(timeParts[1]);
    
    if (isNaN(minutes) || isNaN(seconds)) return null;

    return minutes * 60 + seconds;
  };

  const handleChapterClick = (time) => {
    const totalSeconds = parseTimeString(time);
    if (totalSeconds === null) return;

    // 모바일에서 챕터 클릭 시 플레이어 탭으로 전환
    if (isMobile && setActiveMainTab) {
      setActiveMainTab(0);
      
      // 탭 전환 애니메이션 완료 후 seekTo 실행
      setTimeout(() => {
        if (playerRef?.current && typeof playerRef.current.seekTo === 'function') {
          playerRef.current.seekTo(totalSeconds, true);
          
          // 재생 시도
          setTimeout(() => {
            if (playerRef.current && typeof playerRef.current.playVideo === 'function') {
              playerRef.current.playVideo();
            }
          }, 100);
        }
      }, 350); // 애니메이션 시간과 맞춤
      return;
    }
    
    // 데스크톱이거나 이미 플레이어 탭인 경우 즉시 실행
    if (!playerRef?.current) return;

    if (typeof playerRef.current.seekTo === 'function') {
      playerRef.current.seekTo(totalSeconds, true);
      
      setTimeout(() => {
        if (playerRef.current && typeof playerRef.current.playVideo === 'function') {
          playerRef.current.playVideo();
        }
      }, 300);
    }
  };

  const scrollToChapter = (chapterIndex) => {
    if (scrollContainerRef.current) {
      const chapterElement = document.getElementById(`chapter-${chapterIndex + 1}`);
      if (chapterElement) {
        const container = scrollContainerRef.current;
        const elementTop = chapterElement.offsetTop;
        
        container.scrollTo({
          top: elementTop - 150, // 150px 여유 공간으로 증가하여 제목이 잘 보이도록
          behavior: 'smooth'
        });
      }
    }
  };

  return {
    scrollContainerRef,
    handleChapterClick,
    scrollToChapter
  };
}; 